import { ReactNode } from "react";

import FlashPCBLibLabel from "../../FlashPCBLibLabel";

import { COLORS, FONT_SIZE } from "../../../../constants/Styles";
import { Description, ValueArea } from "./PartDetailsStyles";

const InfoItem = ({
  label,
  value,
  useLibLabel = false,
}: {
  label: string | ReactNode;
  value: string | ReactNode;
  useLibLabel?: boolean;
}) => (
  <Description>
    {useLibLabel ? (
      <FlashPCBLibLabel
        labelStyleProps={{
          color: `${COLORS.secondaryLight}`,
          fontSize: `${FONT_SIZE.size13}`,
        }}
        label={label}
      />
    ) : (
      <span>{label}</span>
    )}
    <ValueArea>{value}</ValueArea>
  </Description>
);

export default InfoItem;
